import React from 'react';

const PopularRoutes = ({ onSelectRoute }) => {
  const popularRoutes = [
    { from: 'Bali (DPS)', to: 'Singapore (SIN)', label: 'Bali → Singapore' },
    { from: 'Bangkok (BKK)', to: 'Singapore (SIN)', label: 'Bangkok → Singapore' },
    { from: 'Bali (DPS)', to: 'Kuala Lumpur (KUL)', label: 'Bali → Kuala Lumpur' },
    { from: 'Bangkok (BKK)', to: 'Kuala Lumpur (KUL)', label: 'Bangkok → Kuala Lumpur' },
    { from: 'Bali (DPS)', to: 'Bangkok (BKK)', label: 'Bali → Bangkok' },
    { from: 'Bangkok (BKK)', to: 'Ho Chi Minh City (SGN)', label: 'Bangkok → Ho Chi Minh' },
  ];

  return (
    <div className="mb-4">
      <h6 className="text-muted mb-3">
        <i className="bi bi-star-fill text-warning me-2"></i>
        Popular Routes for Visa Applications
      </h6>
      <div className="d-flex flex-wrap gap-2">
        {popularRoutes.map((route, index) => (
          <button
            key={index}
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => onSelectRoute(route.from, route.to)}
          >
            {route.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PopularRoutes;

